import React, { useEffect, useRef, useState } from 'react';

import CheckoutOrder from './CheckoutOrder';
import CheckoutTable, { CheckoutTableProps, TableProps } from './CheckoutTable';
import CountDownProgress from './CountDownProgress/CountDownProgress';
import BottomActionBar from './BottomActionBar';
import { Box } from './styles';

import { calculateStartAndEndTimes } from './utils/calculateStartAndEndTimes';
import { currencyFormatter, formattedNumber } from './utils/formatterHelper';
import useGetSenderAndReceiverDetails from './hooks/useGetSenderAndReceiverDetails';

import { ApplicationState } from '../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../../../../utils/formatDate';

import {
  ICheckoutResponse,
  ICustomerIdParams,
  IDataOrderSimulate,
  IItemParamOrderSimulate,
  IItemResponseOrderSimulate,
  IItemSaleInfoMvp,
  IOrderSimulateState,
  ISalesParams
} from '../../../../store/ducks/order-simulate-checkout-mvp/types';
import { addToast } from '../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../store/ducks/toast/types';
import {
  convertKgToTon,
  convertToKg,
  formatTotalWeight,
  getCalculateTotalWeight
} from './utils/unitsOfMeasurement';
import { confirmSale } from '../../../../store/ducks/order-simulate-checkout-mvp/actions';
import { useHistory } from 'react-router-dom';
import LoadingModal from '../../../../components/LoadingModal';
import { ErrorModal } from './ErrorModal';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { useCheckoutMvp } from './hooks/useCheckoutMvp';
import { EOrderSettingsRoutes } from '../OrderSettingsMvp/orderSettings.routes';
import { updateCartItemsQuantity } from '../../../../store/ducks/cart-items-mvp/actions';
import { displayTaxes } from './utils/taxesHelper';
import { purchaseOrigin } from '../../../../services/MVP/utils';
import { formatNumberWithLocale } from '../../../../utils/formatNumbers';
import { EOrdersRoutes } from '../../../Orders/orders.routes';
import { ERoutes } from '../../../../routes';
import { useCartService } from '../../../../services/MVP/useCartService';
import { GetFlag } from '../../../../utils/featureFlag';
import { ILocality2 } from '../../../../store/commomTypes';

interface ICheckoutProps {
  title: string;
  value: string;
}

const MODAL_ERROR_DEFAULT = {
  title: 'Serviço indisponível temporariamente',
  description:
    'Tente novamente mais tarde ou entre em contato com o seu vendedor.',
  buttonRight: {
    title: 'Fechar'
  },
  buttonLeft: {
    title: 'Cancelar pedido',
    canShow: false
  },
  show: false
};

const CheckoutMVP: React.FC = () => {
  const dispatch = useDispatch();
  const tipo_compra = purchaseOrigin();
  const { errorOrdersSent, loadingOrdersSent, orderConfirmationRequested } =
    useSelector((state: ApplicationState) => state.orderSimulateCheckoutMvp);
  const { emitterSelected, receiverSelected } =
    useGetSenderAndReceiverDetails();
  const { getCheckoutFromLocalStorage, updateCheckoutLocalStorage } =
    useCheckoutMvp();
  const [data, setData] = useState<ICheckoutResponse | null>(null);
  const [params, setParams] = useState<IDataOrderSimulate | null>(null);
  const [checkoutState, setCheckoutState] =
    useState<IOrderSimulateState | null>(null);
  const history = useHistory();
  const orderInfoRef = useRef<HTMLDivElement | null>(null);
  const orderTableRef = useRef<HTMLDivElement | null>(null);
  const [tableIsValid, setTableIsValid] = useState(true);
  const [startTimeState, setStartTime] = useState<Date>();
  const [endTimeState, setEndTime] = useState<Date>();
  const [taxValues, setTaxValues] = useState<ICheckoutProps[]>([]);
  // const [orderDetails, setOrderDetails] = useState<ICheckoutProps[]>([]);
  const [totalValues, setTotalValues] = useState<ICheckoutProps[]>([]);
  const [ordersTable, setOrdersTable] = useState<CheckoutTableProps[]>([]);
  const [quantityOfItems, setQuantityOfItems] = useState<number>(0);
  const [itemsSalesInfo, setItemsSalesInfo] = useState<IItemSaleInfoMvp[]>([]);
  const [customerPurchaseId, setCustomerPurchaseId] = useState('');
  const [renderCount, setRenderCount] = useState(0);

  const desabilitarFinalizarPedido = GetFlag('desabilitar_finalizar_pedido');
  const [isLoading, setIsLoading] = useState(false);
  const [modalError, setModalError] = useState(MODAL_ERROR_DEFAULT);

  const loading = loadingOrdersSent || isLoading;

  const currency = 'BRL';

  const goToPage = (pageUrl: string) => {
    history.push(pageUrl);
  };

  const goBack = () => {
    history.goBack();
  };

  const handleClickTagging = (eventName: string, screenName: string) => {
    dispatch(
      sendTagging({
        event: eventName,
        screenName: screenName,
        tipo_compra: tipo_compra,
        bp_emissor: emitterSelected?.customerId,
        bp_recebedor: receiverSelected?.customerId
      })
    );
  };
  useEffect(() => {
    const result = getCheckoutFromLocalStorage();
    setCheckoutState(result);
    setData(result.data);
    setParams(result.params);
    setTimeout(() => {
      const displayWarnings = () => {
        if (result.data?.orders?.length && result.data.orders.length > 1) {
          dispatch(
            addToast({
              message: 'Seu pedido foi separado em mais de uma ordem de venda.',
              type: EToastTypes.INFO,
              durationInMS: 4000
            })
          );
          handleClickTagging('modal_pedido_separado', 'revisar_pedido');
        }
        if (result.data?.orders?.length) {
          const itemWithoutDispDate = result.data.orders.some((table) =>
            table.order.some(
              (order) =>
                !order.extension_attributes.sap_fields.o_item_sap.disp_date
                  .length ||
                !formatDate(
                  order.extension_attributes.sap_fields.o_item_sap.disp_date
                ).length
            )
          );

          if (itemWithoutDispDate) {
            const itemWithoutDispDateTagging = result.data.orders.map(
              (table) => {
                table.order.filter(
                  (order) =>
                    order.extension_attributes.sap_fields.o_item_sap.disp_date
                      .length === 0 ||
                    formatDate(
                      order.extension_attributes.sap_fields.o_item_sap.disp_date
                    ).length === 0
                );
              }
            );

            dispatch(
              sendTagging({
                event: 'sem_estimativa_entrega',
                screenName: 'carrinho',
                tipo_compra: tipo_compra,
                cod_prod: itemWithoutDispDateTagging
              })
            );
            dispatch(
              addToast({
                message: 'Não há estimativa de entrega de alguns produtos.',
                type: EToastTypes.WARNING,
                durationInMS: 4000
              })
            );
          }
        }
      };
      displayWarnings();
    }, 1000);
  }, []);

  useEffect(() => {
    if (
      ordersTable.length > 0 &&
      params?.items.length != 0 &&
      ordersTable.flatMap((order) => order.orderItems.length > 0)
    ) {
      dispatch(
        sendTagging({
          event: 'begin_checkout',
          ecommerce: {
            currency: 'BRL',
            value: currencyFormatter({
              amount: Number(
                data?.o_price_sap_totals.price_with_discount_total ?? '0'
              ),
              currency
            }),
            screenName: 'revisar_pedido',
            tipo_compra: tipo_compra,
            bp_emissor: emitterSelected?.customerId,
            bp_recebedor: receiverSelected?.customerId,
            items: ordersTable.flatMap((order) =>
              order.orderItems.map((product) => ({
                screenName: 'revisar_pedido',
                tipo_compra: tipo_compra,
                item_id: product.productId,
                item_name: product.itemName,
                item_category:
                  params?.items.find((item) => item.sku === product.productId)
                    ?.item_category ?? 'tipo de produto indisponivel',
                price: product.itemPrice,
                unidade_de_medida: getMeasurementUnit(product.itemQuantity),
                quantity: product.itemQuantity,
                data_desejada: product.itemDesiredDate,
                pagamento: product.itemPayment,
                beneficio_fiscal: product.itemTaxBenefit,
                destinacao: product.itemDestiny,
                num_ordem_venda: order.orderNumber + 1,
                preco_sem_impostos: product.itemPrice,
                estimativa_entrega: product.itemDeliveryEstimate.length
                  ? product.itemDeliveryEstimate
                  : 'Sem estimativa'
              }))
            )
          }
        })
      );
    }
  }, [ordersTable, params]);
  function getMeasurementUnit(value: string): string {
    const spacevalue = value.indexOf(' ');
    return value.slice(spacevalue, value.length).trim();
  }
  useEffect(() => {
    mapOrders();
    const setStopwatch = () => {
      if (data?.cartUpdatedIn) {
        const { startTime, endTime } = calculateStartAndEndTimes(
          data.cartUpdatedIn
        );
        setStartTime(startTime);
        setEndTime(endTime);
      }
    };
    setStopwatch();

    const setQtyOfItems = () => {
      if (data?.orders) {
        let quantity = 0;
        data.orders.forEach((order) => (quantity += order.order.length));
        return quantity;
      }
      return 0;
    };
    const qtyOfItems = setQtyOfItems();
    setQuantityOfItems(qtyOfItems);

    const setTaxes = () => {
      const taxes = displayTaxes(data);
      setTaxValues(taxes);
    };
    setTaxes();

    const setOrderValues = () => {
      const values = [
        {
          title: 'Preço total do pedido',
          value: currencyFormatter({
            amount: Number(
              data?.o_price_sap_totals.price_with_discount_total ?? '0'
            ),
            currency
          }),
          tooltipText:
            'O preço total do pedido considera todos os valores do seu pedido, inclusive impostos e descontos.'
        },
        {
          title: 'Preço total sem impostos',
          value: currencyFormatter({
            amount: Number(data?.o_price_sap_totals.price_net ?? '0'),
            currency
          }),
          tooltipText:
            'O preço total sem impostos considera todos os valores do seu pedido, inclusive descontos mas excluindo impostos.'
        }
      ];
      setTotalValues(values);
    };
    setOrderValues();

    const setTable = () => {
      if (data?.orders) {
        const table: CheckoutTableProps[] = [];
        data.orders.forEach((orders, indexTable) => {
          const orderTable: TableProps[] = orders.order.map((order, index) => ({
            key: index,
            itemPositionNumber:
              order.extension_attributes.item_id_gerdau.length > 0
                ? Number(order.extension_attributes.item_id_gerdau)
                : undefined,
            itemName:
              params?.items.find(
                (orderParam) => orderParam.material === order.sku
              )?.name ?? '',
            itemQuantity: `${formattedNumber(
              Number(order.qty)
            )} ${order.extension_attributes.measure_unity_gerdau.toUpperCase()}`,
            itemDesiredDate: formatDate(
              order.extension_attributes.expected_date_gerdau
            ),
            itemDeliveryEstimate: order.extension_attributes.sap_fields
              .o_item_sap.disp_date.length
              ? formatDate(
                  order.extension_attributes.sap_fields.o_item_sap.disp_date
                )
              : 'Sem estimativa',
            itemDestiny:
              params?.items.find(
                (param) =>
                  param.material === order.sku &&
                  param.industrialType ===
                    order.extension_attributes.destination_gerdau
              )?.description ?? '',
            itemTaxBenefit: order.extension_attributes.sap_fields.o_item_sap
              .beneficio.length
              ? order.extension_attributes.sap_fields.o_item_sap.beneficio
              : 'Nenhum',
            itemPayment:
              order.extension_attributes.payment_terms_description_gerdau ?? '',
            itemPrice: currencyFormatter({
              amount: Number(
                order.extension_attributes.sap_fields.o_price_sap
                  .price_with_discount_total
              ),
              currency
            }),
            productId: order.sku
          }));

          table.push({
            orderNumber: String(indexTable),
            orderItems: orderTable
          });
        });

        setOrdersTable(table);
      }
    };
    setTable();

    setRenderCount(renderCount + 1);
  }, [data]);

  const formatAddress = (data: ILocality2): string => {
    if (!data) {
      return '';
    }
    const { address, district, city, state, zipCode } = data;
    const addressParts = [address, district, city, state, zipCode]
      .filter(Boolean)
      .join(' - ');
    return addressParts;
  };

  const details = [
    {
      title: 'Emissor do pedido',
      value: emitterSelected?.name ?? ''
    },
    {
      title: 'CNPJ do emissor',
      value: emitterSelected?.taxNumber ?? ''
    },
    {
      title: 'Endereço do emissor',
      value: formatAddress(emitterSelected?.locality)
    },
    {
      title: 'Nº do cliente emissor',
      value: emitterSelected?.customerId ?? ''
    },
    {
      title: 'Recebedor do pedido',
      value: receiverSelected?.name ?? ''
    },
    {
      title: 'CNPJ do recebedor',
      value: receiverSelected?.taxNumber ?? ''
    },
    {
      title: 'Endereço do recebedor',
      value: formatAddress(receiverSelected?.locality)
    },
    {
      title: 'Nº do cliente recebedor',
      value: receiverSelected?.customerId ?? ''
    },
    {
      title: 'Peso total',
      value: params && params.items ? formatTotalWeight(params.items) : '0'
    },
    {
      title: 'Quantidade de itens',
      value: `${quantityOfItems}`
    }
  ].map((detail) => ({ ...detail, value: detail.value || '' }));

  const mapOrders = async () => {
    if (data?.orders.length && params?.items.length) {
      setIsLoading(true);
      const purchaseId =
        data.orders[0].order[0].extension_attributes.sap_fields.o_header_sap
          .purch_no_c ?? '';
      setCustomerPurchaseId(purchaseId);
      const salesInfo: IItemSaleInfoMvp[] = data.orders
        .flatMap((item) => item.order)
        .map((subItem) => {
          const item = params.items.find((item) =>
            matchingItems(item, subItem)
          );
          return {
            activitySector: item?.activitySector,
            benefit:
              subItem.extension_attributes.sap_fields.o_item_sap.beneficio,
            description: item?.description,
            consumptionOrder:
              item?.description.toLowerCase() === 'consumo' ? 'X' : undefined,
            customerPurchaseItem:
              subItem?.extension_attributes.sap_fields.o_header_sap.purch_no_c,
            distrChannel: Number(
              subItem.extension_attributes.sap_fields.o_header_sap.distr_chan
            ),
            industrialType: item?.industrialType,
            material:
              subItem.extension_attributes.sap_fields.o_item_sap.material,
            plant: Number(
              subItem.extension_attributes.sap_fields.o_item_sap.plant
            ),
            salesGroup:
              subItem.extension_attributes.sap_fields.o_header_sap.sales_grp,
            salesOrg:
              subItem.extension_attributes.sap_fields.o_header_sap.sales_org,
            salesOffice:
              subItem.extension_attributes.sap_fields.o_header_sap.sales_off,
            quantity: subItem.qty,
            requiredDate: subItem.extension_attributes.expected_date_gerdau,
            sku: subItem.sku,
            term: subItem.extension_attributes.payment_type_gerdau,
            unityMeasure: subItem.extension_attributes.measure_unity_gerdau,
            totalWeightInTon: formatNumberWithLocale({
              value:
                item && item.measureUnits
                  ? convertKgToTon(
                      convertToKg(
                        Number(subItem.qty),
                        item.measureUnits,
                        subItem.extension_attributes.measure_unity_gerdau
                      )
                    )
                  : 0
            })
          };
        });

      const incompleteInformation = salesInfo.find(
        (sales) =>
          !sales.activitySector ||
          !sales.industrialType ||
          !sales.sku ||
          !sales.unityMeasure ||
          !sales.quantity
      );

      if (incompleteInformation) {
        setItemsSalesInfo(salesInfo);
        setIsLoading(false);

        setModalError((prev) => ({
          ...prev,
          description:
            'Seu pedido contém informações desatualizadas. Atualize os dados no carrinho para continuar.',
          title: 'Atualize o seu pedido',
          buttonRight: {
            title: 'Atualizar pedido'
          },
          buttonLeft: {
            ...prev.buttonLeft,
            canShow: true
          },
          show: true
        }));
        return;
      }

      setItemsSalesInfo(salesInfo);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const updateOrderConfirmationStatus = () => {
      if (orderConfirmationRequested && checkoutState) {
        updateCheckoutLocalStorage({
          ...checkoutState,
          orderConfirmationRequested,
          ordersTable
        });
        const result = getCheckoutFromLocalStorage();
        setCheckoutState(result);
        // pedido enviado e informações do pedido salvas
        dispatch(updateCartItemsQuantity(0));
        goToPage(`${EOrderSettingsRoutes.FINALIZE_ORDER}`);
      }
    };
    updateOrderConfirmationStatus();
  }, [orderConfirmationRequested]);

  useEffect(() => {
    (() => {
      if (checkoutState) {
        updateCheckoutLocalStorage(checkoutState);
      }
    })();
  }, [checkoutState]);

  const matchingItems = (
    bodyOrderSimulate: IItemParamOrderSimulate,
    responseOrderSimulate: IItemResponseOrderSimulate
  ) => {
    const isSameSku = bodyOrderSimulate.sku === responseOrderSimulate.sku;
    const isSameBenefit =
      bodyOrderSimulate.benefit ===
        responseOrderSimulate.extension_attributes.sap_fields.o_item_sap
          .beneficio ||
      bodyOrderSimulate.benefit ===
        responseOrderSimulate.extension_attributes.sap_fields.o_item_sap
          .beneficiocode;
    const isSameIndustrialType =
      bodyOrderSimulate.industrialType ===
      responseOrderSimulate.extension_attributes.destination_gerdau;
    const isSamePaymentType =
      bodyOrderSimulate.term ===
      responseOrderSimulate.extension_attributes.payment_type_gerdau;
    const isSameRequiredDate =
      formatDate(bodyOrderSimulate.requiredDate) ===
      formatDate(
        responseOrderSimulate.extension_attributes.expected_date_gerdau
      );
    const isSameUnityMeasure =
      bodyOrderSimulate.unityMeasure ===
      responseOrderSimulate.extension_attributes.measure_unity_gerdau;

    return (
      isSameSku &&
      isSameBenefit &&
      isSameIndustrialType &&
      isSamePaymentType &&
      isSameRequiredDate &&
      isSameUnityMeasure
    );
  };

  const updateTable = (item: ICustomerIdParams) => {
    const dataCopy = { ...checkoutState! };

    if (dataCopy.data && checkoutState?.data) {
      const tempOrders = [...dataCopy.data!.orders];
      const tempOrderTable = tempOrders[Number(item.salesOrderId)];
      const itemTemp = tempOrderTable.order.find(
        (order, index) => order.sku === item.itemId && index === item.index
      );
      if (
        !itemTemp ||
        itemTemp.extension_attributes.item_id_gerdau == item.customerId
      ) {
        return;
      }

      itemTemp.extension_attributes.item_id_gerdau = item.customerId;

      setCheckoutState({
        ...checkoutState,
        data: { ...checkoutState!.data, orders: tempOrders }
      });
      setData(dataCopy.data);
    }
  };

  const updateCustomerId = (customerId: string) => {
    if (customerId === customerPurchaseId) {
      return;
    }

    const dataCopy = { ...checkoutState! };
    if (dataCopy.data && checkoutState?.data) {
      const tempOrders = [...dataCopy.data.orders];
      tempOrders.forEach((orders) => {
        orders.order.forEach((order) => {
          order.extension_attributes.sap_fields.o_header_sap.purch_no_c =
            customerId;
        });
      });

      setCheckoutState({
        ...checkoutState,
        data: { ...checkoutState!.data, orders: tempOrders }
      });
      setData(dataCopy.data);
    }
  };

  useEffect(() => {
    if (errorOrdersSent) {
      handleClickTagging('erro_credito_expirado', 'finalizar_pedido');
    }
    setModalError({ ...MODAL_ERROR_DEFAULT, show: errorOrdersSent });
  }, [errorOrdersSent]);

  const addParagraphBeforeLastDiv = (htmlString: string) => {
    const lastDivIndex = htmlString.lastIndexOf('</div>');
    const tagNotFound = lastDivIndex === -1;
    if (tagNotFound) {
      return htmlString;
    }
    const additionalContent =
      '<p>O preço e a estimativa de entrega podem sofrer oscilações.</p>';
    const newHtmlString =
      htmlString.slice(0, lastDivIndex) +
      additionalContent +
      htmlString.slice(lastDivIndex);

    return newHtmlString;
  };

  /**
   * Aciona action que irá confirmar o pedido
   */
  const sendOrders = () => {
    // salva para a possibilidade de ter que gerar PDF
    const infoContentHtml = orderInfoRef.current?.innerHTML;
    const tableHtml = addParagraphBeforeLastDiv(
      orderTableRef.current?.innerHTML ?? ''
    );

    const totalWeight = getCalculateTotalWeight(params!.items);

    setTimeout(() => {
      const salesParams: ISalesParams = {
        emitterId: emitterSelected!.customerId,
        receiverId: receiverSelected?.customerId as string,
        data: itemsSalesInfo,
        customerOrder: customerPurchaseId,
        cartNumber: checkoutState!.params!.cartNumber
      };

      dispatch(confirmSale(salesParams));
      setCheckoutState({
        ...checkoutState!,
        pdf: { text: infoContentHtml!, table: tableHtml! }
      });
    }, 1000);
  };

  const setTableValidity = (isValid: boolean) => {
    setTableIsValid(isValid);
  };

  const modalButtonRight = () => {
    if (modalError.buttonRight.title === 'Atualizar pedido') {
      dispatch(
        sendTagging({
          event: 'modal_atualizar_pedido',
          screenName: 'carrinho',
          etapa: 'atualizar_pedido'
        })
      );
    }
    setModalError(MODAL_ERROR_DEFAULT);
    goBack();
  };

  const modalButtonLeft = () => {
    setModalError(MODAL_ERROR_DEFAULT);
    dispatch(
      sendTagging({
        event: 'modal_atualizar_pedido',
        screenName: 'carrinho',
        etapa: 'cancelar_pedido'
      })
    );
    goToPage(`${ERoutes.PURCHASE}/commerce/${EOrdersRoutes.STEEL_TYPE_CHOOSE}`);
  };

  return (
    <Box>
      <div ref={orderInfoRef}>
        <CheckoutOrder
          orderDetails={details}
          orderValues={totalValues}
          orderTax={taxValues}
          updateCustomerId={updateCustomerId}
        />
      </div>
      {startTimeState && endTimeState && (
        <CountDownProgress
          {...{ startTime: startTimeState, endTime: endTimeState }}
        />
      )}
      <div ref={orderTableRef}>
        <CheckoutTable
          data={ordersTable}
          totalPrice={currencyFormatter({
            amount: Number(
              data?.o_price_sap_totals.price_with_discount_total ?? '0'
            ),
            currency
          })}
          setTableValidity={setTableValidity}
          updateTableItem={updateTable}
        />
      </div>

      <BottomActionBar
        item={{
          title: `Preço total do pedido: ${currencyFormatter({
            amount: Number(
              data?.o_price_sap_totals.price_with_discount_total ?? '0'
            ),
            currency
          })}`,
          value: 'O preço e a estimativa de entrega podem sofrer oscilações.',
          placement: 'topLeft',
          tooltipText:
            'O preço total do pedido considera todos os valores do seu pedido, inclusive impostos e descontos.'
        }}
        primaryBtn={{
          title: 'Finalizar pedido',
          primaryEvent: sendOrders,
          disabled:
            !tableIsValid ||
            !data?.orders ||
            loading ||
            desabilitarFinalizarPedido
        }}
        secondaryBtn={{
          title: 'Alterar Pedido',
          secondaryEvent: () => goBack()
        }}
      />
      <LoadingModal
        enabled={loadingOrdersSent}
        title="Aguarde alguns instantes"
        message="Finalizando o pedido ..."
      />
      <ErrorModal
        description={modalError.description}
        title={modalError.title}
        buttonLeft={{
          ...modalError.buttonLeft,
          onClick: modalButtonLeft
        }}
        buttonRight={{ ...modalError.buttonRight, onClick: modalButtonRight }}
        show={modalError.show}
      ></ErrorModal>
    </Box>
  );
};

export default CheckoutMVP;
